import  {eXcell,__extends} from './eXcell';

var eXcell_win = (function (_super) {
    __extends(eXcell_win, _super);
    function eXcell_win(a) {
        _super.call(this);
        if (!a) {
            return;
        }
        this.cell = a;
        this.grid = a.parentNode.grid;
    }
    eXcell_win.prototype.edit = function () {
        if (!window.dhx_globalImgPath) {
            window.dhx_globalImgPath = this.grid.imgURL;
        }
        this.val = this.getValue();
        this.obj = {};
        var colI = this.cell._cellIndex;
        if (this.grid.showDialogFun[colI] != null &&
            typeof this.grid.showDialogFun[colI] == "function") {
            this.grid.showDialogFun[colI](this, this.obj, colI);
        }
    };
    eXcell_win.prototype.detach = function () {
        var c = "";
        c = this.obj.value;
        if (c == "") {
            this.cell._clearCell = true;
        }
        else {
            this.cell._clearCell = false;
        }
        this.setValue(c);
    };
    eXcell_win.prototype.isDisabled = function () {
        return this.cell._disabled;
    };
    eXcell_win.prototype.getValue = function () {
        if (this.cell._clearCell) {
            return "";
        }
        return this.cell.innerHTML.toString()._dhx_trim();
    };
    return eXcell_win;
})(eXcell);
window.eXcell_win = eXcell_win;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_win.js